import { PageHeader } from '../../components/PageHeader';
import { useCurrentUser } from '../../auth/CurrentUserProvider';
import { RecoveryCodesReveal } from './RecoveryCodesReveal';
import { TotpEnrollmentWizard } from './TotpEnrollmentWizard';
import { TotpStatusCard } from './TotpStatusCard';
import { useTotpEnrollment } from './use-totp-enrollment';

export function SecurityPage() {
  const { state } = useCurrentUser();
  const { enrollment, error, submitting, start, verify, finish, disable, cancel } = useTotpEnrollment();
  const user = state.status === 'authenticated' ? state.user : undefined;

  return (
    <>
      <PageHeader breadcrumbs={[{ label: 'Account' }]} title="Security" description="Manage two-factor authentication for your account." />
      <div className="max-w-lg">
        {enrollment.phase === 'idle' && (
          <TotpStatusCard enabled={user?.totpEnabled ?? false} error={error} submitting={submitting} onEnable={() => start()} onDisable={disable} />
        )}
        {enrollment.phase === 'secret' && (
          <TotpEnrollmentWizard
            secret={enrollment.secret}
            qrCodeDataUrl={enrollment.qrCodeDataUrl}
            error={error}
            submitting={submitting}
            onVerify={verify}
            onCancel={cancel}
          />
        )}
        {enrollment.phase === 'recovery-codes' && <RecoveryCodesReveal codes={enrollment.codes} onDone={finish} />}
      </div>
    </>
  );
}
